import service from "@/utils/request";

// 意向度列表
export const getFollowLatentApi = () => {
  return service({
    url: "/api/v1/student/follow/intent",
    method: "get",
  });
};

// 跟进阶段
export const getFollowStageApi = (params: {
  include_del?: number;
  student_id?: number;
}) => {
  return service({
    url: "/api/v1/student/follow/stage",
    method: "get",
    params,
  });
};

// 跟进方式
export const getFollowModeApi = () => {
  return service({
    url: "/api/v1/student/follow/mode",
    method: "get",
  });
};

// 学员汇总跟进列表
export interface getFollowAllListData {
  page: number;
  page_size: number;
  key_word?: string;
  staff_id?: number;
  stage?: number;
  mode?: number;
  status?: number;
  pre_follow_start_time?: number;
  pre_follow_end_time?: number;
  status_arr?: [];
  student_id?: number;
  intent_arr?: number;
  follow_start_time?: string;
  follow_end_time?: string;
}
export const getFollowAllListApi = (data: getFollowAllListData) => {
  return service({
    url: "/api/v1/student/follow/all_list",
    method: "post",
    data,
  });
};

// 跟进记录详情
export const getFollowLogDetailApi = (params: { follow_id: number }) => {
  return service({
    url: "/api/v1/student/follow/detail",
    method: "get",
    params,
  });
};

// 删除跟进记录
export const deletefollowLogApi = (data: { follow_id: number }) => {
  return service({
    url: "/api/v1/student/follow/del",
    method: "post",
    data,
  });
};

// 取消跟进记录
export const cancelfollowApi = (data: {
  follow_id: number;
  cancel_remark?: string;
}) => {
  return service({
    url: "/api/v1/student/follow/cancel",
    method: "post",
    data,
  });
};

// 添加跟进记录
export interface addfollowLogData {
  student_id?: number;
  student_follow_id?: number;
  mode?: number;
  stage?: number;
  intent?: number;
  content?: string;
  follow_content?: string;
  pre_follow_time?: number;
  images?: string[];
}
export const addfollowLogApi = (data: addfollowLogData) => {
  return service({
    url: "/api/v1/student/follow/add",
    method: "post",
    data,
  });
};

// 编辑跟进记录
export interface editfollowLogData {
  follow_id: number;
  content?: string;
  pre_follow_time?: number;
}
export const editfollowLogApi = (data: editfollowLogData) => {
  return service({
    url: "/api/v1/student/follow/edit",
    method: "post",
    data,
  });
};

// 跟进记录导出
export const studentFollowExportApi = (data: getFollowAllListData) => {
  return service({
    url: "/api/v1/student/follow/all_list/export",
    method: "post",
    data,
  });
};
